import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
} from "reactstrap";
import user from "../../assets/images/user.png";
import Loader from "../../shared/Loader";
import { errorToast, successToast } from "../../shared/Toast";
import Breadcrumb from "../common/breadcrumb";
import axiosInstance from "../../utils/axios"; // Use axiosInstance for consistency

const EditArticle = () => {
    const navigate = useNavigate();
    const { articleId } = useParams();
    const [loading, setLoading] = useState(false);
    const [articleData, setArticleData] = useState({
        author: "",
        description: "",
    });
    const [imageForPayload, setImageForPayload] = useState(null);
    const [dummyImg, setDummyImg] = useState(user);

    const handleInputChange = (e, key) => {
        setArticleData((prev) => ({ ...prev, [key]: e.target.value }));
    };

    const gradientButtonStyle = {
        padding: '10px 20px',
        margin: '0 10px',
        borderRadius: '8px',
        background: 'linear-gradient(135deg, #6B73FF 0%, #000DFF 100%)',
        color: 'white',
        fontWeight: '500',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        border: 'none',
        cursor: 'pointer',
        transition: 'transform 0.2s',
    };

    const handleMouseOver = (e) => {
        e.target.style.transform = 'scale(1.05)';
    };

    const handleMouseOut = (e) => {
        e.target.style.transform = 'scale(1)';
    };

    const _handleImgChange = (e) => {
        e.preventDefault();
        const image = e.target.files[0];
        setImageForPayload(image);

        let reader = new FileReader();
        reader.onload = () => {
            setDummyImg(reader.result);
        };
        reader.readAsDataURL(image);
    };

    const handleDiscard = () => {
        navigate("/article/article-list");
    };

    const handleValidSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const formData = new FormData();

            formData.append("author", articleData.author);
            formData.append("description", articleData.description);
            formData.append("dataType", "article");

            // Only append the image if a new one has been selected
            if (imageForPayload) {
                formData.append("image1", imageForPayload, imageForPayload?.name);
            }

            const response = await axiosInstance.put(
                `/api/article/updateArticle/${articleId}`,
                formData,
                {
                    rawRequest: true,
                }
            );

            if (response.data && !response.data.isError) {
                successToast("Article updated successfully");
                navigate("/article/article-list"); // Corrected navigation path
            } else {
                errorToast(response.data.message || "Failed to update article");
            }
        } catch (error) {
            console.error("Error updating article:", error);
            errorToast(error.response?.data?.message || "Failed to update article");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchArticleData = async () => {
            setLoading(true);
            try {
                const response = await axiosInstance.get(`/api/article/getArticle/${articleId}`);
                console.log("API Response:", response); // Yeh pura response dekho

                if (response.status === 200) {
                    const article = response.data.data; // Actual article data yahan hai
                    console.log("Article Data:", article); // Yeh check karo

                    setArticleData({
                        author: article?.author || "",
                        description: article?.description || "",
                    });
                    setDummyImg(article?.image || user); // Image set karo
                    setImageForPayload(null); // Reset image payload
                }
            } catch (error) {
                console.error("Error fetching article data:", error);
                errorToast("Failed to fetch article data");
            } finally {
                setLoading(false);
            }
        };

        fetchArticleData();
    }, [articleId]);

    return (
        <Fragment>
            <Breadcrumb title="Edit Article" parent="Articles" />
            <Container fluid={true}>
                {loading ? (
                    <Loader />
                ) : (
                    <Row>
                        <Col sm="12">
                            <Card>
                                <CardHeader>
                                    <h5>Edit Article</h5>
                                </CardHeader>
                                <CardBody>
                                    <Row className="product-adding">
                                        <Col xl="5">
                                            <div className="add-product">
                                                <Row>
                                                    <Col xl="3 xl-50" sm="6 col-3">
                                                        <div className="box-input-file">
                                                            <Input
                                                                className="upload"
                                                                type="file"
                                                                onChange={(e) => _handleImgChange(e)}
                                                            />
                                                            <img
                                                                alt="article"
                                                                src={dummyImg}
                                                                style={{ width: 50, height: 50 }}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                        <Col xl="7">
                                            <Form
                                                className="needs-validation add-product-form"
                                                onSubmit={handleValidSubmit}
                                            >
                                                <div className="form form-label-center">
                                                    <FormGroup className="form-group mb-3 row">
                                                        <Label className="col-xl-3 col-sm-4 mb-0">
                                                            Author:
                                                        </Label>
                                                        <div className="col-xl-8 col-sm-7">
                                                            <Input
                                                                className="form-control"
                                                                type="text"
                                                                required
                                                                value={articleData.author}
                                                                onChange={(e) =>
                                                                    handleInputChange(e, "author")
                                                                }
                                                            />
                                                        </div>
                                                        <div className="valid-feedback">Looks good!</div>
                                                    </FormGroup>
                                                    <FormGroup className="form-group mb-3 row">
                                                        <Label className="col-xl-3 col-sm-4 mb-0">
                                                            Description:
                                                        </Label>
                                                        <div className="col-xl-8 col-sm-7">
                                                            <Input
                                                                className="form-control"
                                                                type="textarea"
                                                                required
                                                                value={articleData.description}
                                                                onChange={(e) =>
                                                                    handleInputChange(e, "description")
                                                                }
                                                            />
                                                        </div>
                                                        <div className="valid-feedback">Looks good!</div>
                                                    </FormGroup>
                                                </div>
                                                <div className="offset-xl-3 offset-sm-4">
                                                    <Button
                                                        type="submit"
                                                        style={gradientButtonStyle}
                                                        onMouseOver={handleMouseOver}
                                                        onMouseOut={handleMouseOut}
                                                    >
                                                        Update
                                                    </Button>
                                                    <Button
                                                        onClick={handleDiscard}
                                                        type="button"
                                                        style={{ ...gradientButtonStyle, background: 'linear-gradient(135deg, #FF6B6B 0%, #FF0000 100%)' }}
                                                        onMouseOver={handleMouseOver}
                                                        onMouseOut={handleMouseOut}
                                                    >
                                                        Discard
                                                    </Button>
                                                </div>
                                            </Form>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}
            </Container>
        </Fragment>
    );
};

export default EditArticle;